import { _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsx } from 'react/jsx-runtime';

/**
 * A `<form>` element that prevents `submit` behavior when a button is pressed.
 * This is useful for wrapping groups of input elements that should trigger a
 * neighboring button's `onClick` handler when the "Enter" is pressed. It
 * provides no styling
 */
var Form = function (props) {
    var handleSubmit = function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    return jsx("form", __assign({ onSubmit: handleSubmit }, props), void 0);
};

export { Form as F };
